import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/terms/page.tsx");
